import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgAgenda = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 4H20V20H2V4H6V2H8V4H14V2H16V4ZM4 6V18H18V6H4ZM6 9H8V11H6V9ZM6 13H8V15H6V13ZM14 9H16V11H14V9ZM10 9H12V11H10V9ZM10 13H12V15H10V13Z"
      fill="currentColor"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgAgenda);

export default ForwardRef;
